"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeSubTypes;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @param {Error} Base
 * @returns {undefined}
 */
function makeSubTypes(Base) {
  /**
   * NetworkOrCORSError
   */
  var NetworkOrCORSError = /*#__PURE__*/function (_Base) {
    (0, _inherits2.default)(NetworkOrCORSError, _Base);
    var _super = _createSuper(NetworkOrCORSError);
    function NetworkOrCORSError() {
      (0, _classCallCheck2.default)(this, NetworkOrCORSError);
      return _super.apply(this, arguments);
    }
    return (0, _createClass2.default)(NetworkOrCORSError);
  }(Base);
  /**
   * BadRequest
   */
  var BadRequest = /*#__PURE__*/function (_Base2) {
    (0, _inherits2.default)(BadRequest, _Base2);
    var _super2 = _createSuper(BadRequest);
    function BadRequest() {
      (0, _classCallCheck2.default)(this, BadRequest);
      return _super2.apply(this, arguments);
    }
    return (0, _createClass2.default)(BadRequest);
  }(Base);
  /**
   * Unauthorized
   */
  var Unauthorized = /*#__PURE__*/function (_BadRequest) {
    (0, _inherits2.default)(Unauthorized, _BadRequest);
    var _super3 = _createSuper(Unauthorized);
    function Unauthorized() {
      (0, _classCallCheck2.default)(this, Unauthorized);
      return _super3.apply(this, arguments);
    }
    return (0, _createClass2.default)(Unauthorized);
  }(BadRequest);
  /**
   * PaymentRequired
   */
  var PaymentRequired = /*#__PURE__*/function (_BadRequest2) {
    (0, _inherits2.default)(PaymentRequired, _BadRequest2);
    var _super4 = _createSuper(PaymentRequired);
    function PaymentRequired() {
      (0, _classCallCheck2.default)(this, PaymentRequired);
      return _super4.apply(this, arguments);
    }
    return (0, _createClass2.default)(PaymentRequired);
  }(BadRequest);
  /**
   * Forbidden
   */
  var Forbidden = /*#__PURE__*/function (_BadRequest3) {
    (0, _inherits2.default)(Forbidden, _BadRequest3);
    var _super5 = _createSuper(Forbidden);
    function Forbidden() {
      (0, _classCallCheck2.default)(this, Forbidden);
      return _super5.apply(this, arguments);
    }
    return (0, _createClass2.default)(Forbidden);
  }(BadRequest);
  /**
   * NotFound
   */
  var NotFound = /*#__PURE__*/function (_BadRequest4) {
    (0, _inherits2.default)(NotFound, _BadRequest4);
    var _super6 = _createSuper(NotFound);
    function NotFound() {
      (0, _classCallCheck2.default)(this, NotFound);
      return _super6.apply(this, arguments);
    }
    return (0, _createClass2.default)(NotFound);
  }(BadRequest);
  /**
   * MethodNotAllowed
   */
  var MethodNotAllowed = /*#__PURE__*/function (_BadRequest5) {
    (0, _inherits2.default)(MethodNotAllowed, _BadRequest5);
    var _super7 = _createSuper(MethodNotAllowed);
    function MethodNotAllowed() {
      (0, _classCallCheck2.default)(this, MethodNotAllowed);
      return _super7.apply(this, arguments);
    }
    return (0, _createClass2.default)(MethodNotAllowed);
  }(BadRequest);
  /**
   * NotAcceptable
   */
  var NotAcceptable = /*#__PURE__*/function (_BadRequest6) {
    (0, _inherits2.default)(NotAcceptable, _BadRequest6);
    var _super8 = _createSuper(NotAcceptable);
    function NotAcceptable() {
      (0, _classCallCheck2.default)(this, NotAcceptable);
      return _super8.apply(this, arguments);
    }
    return (0, _createClass2.default)(NotAcceptable);
  }(BadRequest);
  /**
   * ProxyAuthenticationRequired
   */
  var ProxyAuthenticationRequired = /*#__PURE__*/function (_BadRequest7) {
    (0, _inherits2.default)(ProxyAuthenticationRequired, _BadRequest7);
    var _super9 = _createSuper(ProxyAuthenticationRequired);
    function ProxyAuthenticationRequired() {
      (0, _classCallCheck2.default)(this, ProxyAuthenticationRequired);
      return _super9.apply(this, arguments);
    }
    return (0, _createClass2.default)(ProxyAuthenticationRequired);
  }(BadRequest);
  /**
   * RequestTimeout
   */
  var RequestTimeout = /*#__PURE__*/function (_BadRequest8) {
    (0, _inherits2.default)(RequestTimeout, _BadRequest8);
    var _super10 = _createSuper(RequestTimeout);
    function RequestTimeout() {
      (0, _classCallCheck2.default)(this, RequestTimeout);
      return _super10.apply(this, arguments);
    }
    return (0, _createClass2.default)(RequestTimeout);
  }(BadRequest);
  /**
   * Conflict
   */
  var Conflict = /*#__PURE__*/function (_BadRequest9) {
    (0, _inherits2.default)(Conflict, _BadRequest9);
    var _super11 = _createSuper(Conflict);
    function Conflict() {
      (0, _classCallCheck2.default)(this, Conflict);
      return _super11.apply(this, arguments);
    }
    return (0, _createClass2.default)(Conflict);
  }(BadRequest);
  /**
   * Gone
   */
  var Gone = /*#__PURE__*/function (_BadRequest10) {
    (0, _inherits2.default)(Gone, _BadRequest10);
    var _super12 = _createSuper(Gone);
    function Gone() {
      (0, _classCallCheck2.default)(this, Gone);
      return _super12.apply(this, arguments);
    }
    return (0, _createClass2.default)(Gone);
  }(BadRequest);
  /**
   * LengthRequired
   */
  var LengthRequired = /*#__PURE__*/function (_BadRequest11) {
    (0, _inherits2.default)(LengthRequired, _BadRequest11);
    var _super13 = _createSuper(LengthRequired);
    function LengthRequired() {
      (0, _classCallCheck2.default)(this, LengthRequired);
      return _super13.apply(this, arguments);
    }
    return (0, _createClass2.default)(LengthRequired);
  }(BadRequest);
  /**
   * PreconditionFailed
   */
  var PreconditionFailed = /*#__PURE__*/function (_BadRequest12) {
    (0, _inherits2.default)(PreconditionFailed, _BadRequest12);
    var _super14 = _createSuper(PreconditionFailed);
    function PreconditionFailed() {
      (0, _classCallCheck2.default)(this, PreconditionFailed);
      return _super14.apply(this, arguments);
    }
    return (0, _createClass2.default)(PreconditionFailed);
  }(BadRequest);
  /**
   * RequestEntityTooLarge
   */
  var RequestEntityTooLarge = /*#__PURE__*/function (_BadRequest13) {
    (0, _inherits2.default)(RequestEntityTooLarge, _BadRequest13);
    var _super15 = _createSuper(RequestEntityTooLarge);
    function RequestEntityTooLarge() {
      (0, _classCallCheck2.default)(this, RequestEntityTooLarge);
      return _super15.apply(this, arguments);
    }
    return (0, _createClass2.default)(RequestEntityTooLarge);
  }(BadRequest);
  /**
   * RequestUriTooLong
   */
  var RequestUriTooLong = /*#__PURE__*/function (_BadRequest14) {
    (0, _inherits2.default)(RequestUriTooLong, _BadRequest14);
    var _super16 = _createSuper(RequestUriTooLong);
    function RequestUriTooLong() {
      (0, _classCallCheck2.default)(this, RequestUriTooLong);
      return _super16.apply(this, arguments);
    }
    return (0, _createClass2.default)(RequestUriTooLong);
  }(BadRequest);
  /**
   * UnsupportedMediaType
   */
  var UnsupportedMediaType = /*#__PURE__*/function (_BadRequest15) {
    (0, _inherits2.default)(UnsupportedMediaType, _BadRequest15);
    var _super17 = _createSuper(UnsupportedMediaType);
    function UnsupportedMediaType() {
      (0, _classCallCheck2.default)(this, UnsupportedMediaType);
      return _super17.apply(this, arguments);
    }
    return (0, _createClass2.default)(UnsupportedMediaType);
  }(BadRequest);
  /**
   * RequestRangeNotSatisfiable
   */
  var RequestRangeNotSatisfiable = /*#__PURE__*/function (_BadRequest16) {
    (0, _inherits2.default)(RequestRangeNotSatisfiable, _BadRequest16);
    var _super18 = _createSuper(RequestRangeNotSatisfiable);
    function RequestRangeNotSatisfiable() {
      (0, _classCallCheck2.default)(this, RequestRangeNotSatisfiable);
      return _super18.apply(this, arguments);
    }
    return (0, _createClass2.default)(RequestRangeNotSatisfiable);
  }(BadRequest);
  /**
   * ExpectationFailed
   */
  var ExpectationFailed = /*#__PURE__*/function (_BadRequest17) {
    (0, _inherits2.default)(ExpectationFailed, _BadRequest17);
    var _super19 = _createSuper(ExpectationFailed);
    function ExpectationFailed() {
      (0, _classCallCheck2.default)(this, ExpectationFailed);
      return _super19.apply(this, arguments);
    }
    return (0, _createClass2.default)(ExpectationFailed);
  }(BadRequest);
  /**
   * TooManyRequests
   */
  var TooManyRequests = /*#__PURE__*/function (_BadRequest18) {
    (0, _inherits2.default)(TooManyRequests, _BadRequest18);
    var _super20 = _createSuper(TooManyRequests);
    function TooManyRequests() {
      (0, _classCallCheck2.default)(this, TooManyRequests);
      return _super20.apply(this, arguments);
    }
    return (0, _createClass2.default)(TooManyRequests);
  }(BadRequest);
  /**
   * InternalServerError
   */
  var InternalServerError = /*#__PURE__*/function (_Base3) {
    (0, _inherits2.default)(InternalServerError, _Base3);
    var _super21 = _createSuper(InternalServerError);
    function InternalServerError() {
      (0, _classCallCheck2.default)(this, InternalServerError);
      return _super21.apply(this, arguments);
    }
    return (0, _createClass2.default)(InternalServerError);
  }(Base);
  /**
   * NotImplemented
   */
  var NotImplemented = /*#__PURE__*/function (_InternalServerError) {
    (0, _inherits2.default)(NotImplemented, _InternalServerError);
    var _super22 = _createSuper(NotImplemented);
    function NotImplemented() {
      (0, _classCallCheck2.default)(this, NotImplemented);
      return _super22.apply(this, arguments);
    }
    return (0, _createClass2.default)(NotImplemented);
  }(InternalServerError);
  /**
   * BadGateway
   */
  var BadGateway = /*#__PURE__*/function (_InternalServerError2) {
    (0, _inherits2.default)(BadGateway, _InternalServerError2);
    var _super23 = _createSuper(BadGateway);
    function BadGateway() {
      (0, _classCallCheck2.default)(this, BadGateway);
      return _super23.apply(this, arguments);
    }
    return (0, _createClass2.default)(BadGateway);
  }(InternalServerError);
  /**
   * ServiceUnavailable
   */
  var ServiceUnavailable = /*#__PURE__*/function (_InternalServerError3) {
    (0, _inherits2.default)(ServiceUnavailable, _InternalServerError3);
    var _super24 = _createSuper(ServiceUnavailable);
    function ServiceUnavailable() {
      (0, _classCallCheck2.default)(this, ServiceUnavailable);
      return _super24.apply(this, arguments);
    }
    return (0, _createClass2.default)(ServiceUnavailable);
  }(InternalServerError);
  /**
   * GatewayTimeout
   */
  var GatewayTimeout = /*#__PURE__*/function (_InternalServerError4) {
    (0, _inherits2.default)(GatewayTimeout, _InternalServerError4);
    var _super25 = _createSuper(GatewayTimeout);
    function GatewayTimeout() {
      (0, _classCallCheck2.default)(this, GatewayTimeout);
      return _super25.apply(this, arguments);
    }
    return (0, _createClass2.default)(GatewayTimeout);
  }(InternalServerError);
  /**
   * HttpVersionNotSupported
   */
  var HttpVersionNotSupported = /*#__PURE__*/function (_InternalServerError5) {
    (0, _inherits2.default)(HttpVersionNotSupported, _InternalServerError5);
    var _super26 = _createSuper(HttpVersionNotSupported);
    function HttpVersionNotSupported() {
      (0, _classCallCheck2.default)(this, HttpVersionNotSupported);
      return _super26.apply(this, arguments);
    }
    return (0, _createClass2.default)(HttpVersionNotSupported);
  }(InternalServerError);
  (0, _assign.default)(Base, {
    0: NetworkOrCORSError,
    NetworkOrCORSError: NetworkOrCORSError,
    400: BadRequest,
    BadRequest: BadRequest,
    401: Unauthorized,
    Unauthorized: Unauthorized,
    402: PaymentRequired,
    PaymentRequired: PaymentRequired,
    403: Forbidden,
    Forbidden: Forbidden,
    404: NotFound,
    NotFound: NotFound,
    405: MethodNotAllowed,
    MethodNotAllowed: MethodNotAllowed,
    406: NotAcceptable,
    NotAcceptable: NotAcceptable,
    407: ProxyAuthenticationRequired,
    ProxyAuthenticationRequired: ProxyAuthenticationRequired,
    408: RequestTimeout,
    RequestTimeout: RequestTimeout,
    409: Conflict,
    Conflict: Conflict,
    410: Gone,
    Gone: Gone,
    411: LengthRequired,
    LengthRequired: LengthRequired,
    412: PreconditionFailed,
    PreconditionFailed: PreconditionFailed,
    413: RequestEntityTooLarge,
    RequestEntityTooLarge: RequestEntityTooLarge,
    414: RequestUriTooLong,
    RequestUriTooLong: RequestUriTooLong,
    415: UnsupportedMediaType,
    UnsupportedMediaType: UnsupportedMediaType,
    416: RequestRangeNotSatisfiable,
    RequestRangeNotSatisfiable: RequestRangeNotSatisfiable,
    417: ExpectationFailed,
    ExpectationFailed: ExpectationFailed,
    429: TooManyRequests,
    TooManyRequests: TooManyRequests,
    500: InternalServerError,
    InternalServerError: InternalServerError,
    501: NotImplemented,
    NotImplemented: NotImplemented,
    502: BadGateway,
    BadGateway: BadGateway,
    503: ServiceUnavailable,
    ServiceUnavailable: ServiceUnavailable,
    504: GatewayTimeout,
    GatewayTimeout: GatewayTimeout,
    505: HttpVersionNotSupported,
    HttpVersionNotSupported: HttpVersionNotSupported,
    select: function select(statusCode) {
      if (typeof statusCode === 'undefined' || statusCode === null) {
        return Base;
      }
      statusCode = statusCode.statusCode || statusCode;
      var E = Base[statusCode];
      if (E) {
        return E;
      }

      // Fallback to the default for the category (e.g. BadRequest for 429)
      statusCode = "".concat(statusCode.toString().split('').shift(), "00");
      statusCode = (0, _parseInt2.default)(statusCode, 10);
      return Base[statusCode] || Base;
    }
  });
}
//# sourceMappingURL=http-error-subtypes.js.map
